import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideEditFormReferenceModal } from 'actions/forms/editFormReferenceModal';

export const EDIT_FORM_REFERENCE_REQUEST = 'EDIT_FORM_REFERENCE_REQUEST';
export const EDIT_FORM_REFERENCE_SUCCESS = 'EDIT_FORM_REFERENCE_SUCCESS';
export const EDIT_FORM_REFERENCE_ERROR = 'EDIT_FORM_REFERENCE_ERROR';

function request(newFormReference) {
  return {
    type: EDIT_FORM_REFERENCE_REQUEST,
    newFormReference
  };
}

function receive() {
  return {
    type: EDIT_FORM_REFERENCE_SUCCESS
  };
}

function reject() {
  return {
    type: EDIT_FORM_REFERENCE_ERROR
  };
}

export function editFormReference(formId, newFormRef) {
  return (dispatch) => {
    dispatch(request(newFormRef));

    const promise = () => ApiService
      .updateFormReference(formId, newFormRef)
      .then((response) => {
        dispatch(hideEditFormReferenceModal());
        toastr.success('', 'The new form reference has been applied');
        dispatch(receive());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
